import { LoaderFunction, redirect } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { fetchSession } from '@/portal/api/Sessions';

export const loader: LoaderFunction = async () => {
  try {
    const sessionData = await fetchSession();

    // Set Sentry user context when we have valid session data with user
    if (sessionData && sessionData.user) {
      Sentry.setUser({
        id: sessionData.user.id.toString(),
        email: sessionData.user.email,
        username: `${sessionData.user.firstName} ${sessionData.user.lastName}`,
      });
    } else {
      // Clear Sentry user context if no valid user data
      Sentry.setUser(null);
    }

    return sessionData;
  } catch {
    // Clear Sentry user context on authentication failure
    Sentry.setUser(null);
    return redirect('/portal/login');
  }
};
